import PropTypes from 'prop-types';
import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { add, load } from '../../../reducers/clients/clients.actions';
import { clients, loading } from '../../../reducers/clients/clients.reducer';
import { Spinner } from '../../Spinner/Spinner';
import './AdminClients.css';
import ConnectedClientForm from './ClientForm/ClientForm';

export class AdminClients extends React.Component {
  componentDidMount() {
    this.props.load();
  }

  render() {
    return (
      <span>
        <Spinner isLoading={this.props.areClientsLoading} />
        <Row style={{ 'margin-bottom': '15px' }}><Col><Button onClick={this.props.addClient} bsStyle="primary">Add New Client</Button></Col></Row>
        {this.props.clients.map(client => (
          <Row key={client.id}>
            <Col>
              <ConnectedClientForm client={client} />
            </Col>
          </Row>
          ))}
        <Row><Col><Button onClick={this.props.addClient} bsStyle="primary">Add New Client</Button></Col></Row>
      </span>
    );
  }
}

AdminClients.propTypes = {
  load: PropTypes.func.isRequired,
  addClient: PropTypes.func.isRequired,
  areClientsLoading: PropTypes.bool.isRequired,
  clients: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export const mapStateToProps = state => ({
  areClientsLoading: loading(state),
  clients: clients(state),
});

export const mapDispatchToProps = dispatch => ({
  load: () => dispatch(load()),
  addClient: () => dispatch(add()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AdminClients);



// WEBPACK FOOTER //
// ./src/components/Admin/Clients/AdminClients.jsx